import { Component, OnInit, AfterViewInit } from '@angular/core';
import { QuestionProcessingService } from './services/question-processing.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    this.body.classList.remove('hide-body');
  }
  ngOnInit(): void {
    
  }
  title = 'app';
  cssPath : string;
  cssTheme : string;
  body : HTMLElement;
 
  constructor(private questions : QuestionProcessingService)
  {
    //just hackin this in
    // TODO: move this to the basecomponent and use router.
    // if(window.location.pathname == '/dennys') 
    this.ChangeTheme('dennys');
    this.body = document.getElementsByTagName('body')[0];
    
  }

  ChangeTheme(theme: string) : void {
    //gotta clear the old one out first (if it exists), or we run into some CSS collisions
    if(this.cssTheme) document.getElementById(this.cssTheme).remove();
    let cssId = theme;
    if(theme == 'light') {
      this.cssPath = '/assets/css/light-theme.css'
    } else if (theme == 'dennys') {
      this.cssPath = '/assets/css/dennys-theme.css'
    } else {
      this.cssPath = '/assets/css/dark-theme.css'
    }
    console.log(this.cssPath);
    var head  = document.getElementsByTagName('head')[0];
    var link  = document.createElement('link');
    link.id   = cssId;
    link.rel  = 'stylesheet';
    link.type = 'text/css';
    link.href = this.cssPath;
    link.media = 'all';
    head.appendChild(link);
    this.cssTheme = theme;
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/app.component.ts